module.exports = __webpack_public_path__ + "flyer_image_overlay_grunge_texture_006-1dcdbbfb4fc6fbc0343c9917e800d001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/flyer_image_overlay_grunge_texture_006.png
// module id = 1567
// module chunks = 1